import React, { useState } from "react";
import { TextField, Button, Grid } from '@material-ui/core';
import { useHistory } from 'react-router-dom'
import axios from 'axios'
import { useDispatch } from "react-redux";
import { ERROR, LOADING, LOADING_OFF } from '../store/actions/UserAction'
import styled from "styled-components";
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core';
import { lightGreen } from '@material-ui/core/colors';
const greenTheme = createMuiTheme({ palette: { primary: lightGreen } })

const initialLogin = {
    username: '',
    password: '',
}

const Form = styled.form`
    max-width: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    background: white;
    padding: 20% 0;
    /* margin-top: 9rem; */
    margin-top: 5rem;
    margin-bottom: 10rem;

    @media (min-width: ${props => props.theme.mobileBreakpoint}){
        max-width: 80%;
        margin-top: 13rem;
        border: 1px grey solid;
        border-radius: 1.4%;
        padding: 2% 0;
    }
    @media (min-width: ${props => props.theme.tabletBreakpoint}){
        border: 1px grey solid;
        margin-top: 8rem;
        border-radius: 1.4%;
        max-width: 45%;
        
    }
`
const Div = styled.div`
    margin: auto;
`

const StyledTF = styled(TextField)`
    width: 80%;
`

const Login = () => {

    const [login, setLogin] = useState(initialLogin)
    let history = useHistory()
    let dispatch = useDispatch()
    const inputHandler = (e) => {
        setLogin({...login, [e.target.name]: e.target.value})
    }
    const submitHandler = (e) => {
        e.preventDefault()
        dispatch({type: LOADING, payload: ''})
        axios
            .post('https://kzhao-club.herokuapp.com/login', `grant_type=password&username=${login.username}&password=${login.password}`, {
                headers: {
                Authorization: `Basic ${btoa('system-client:system-secret')}`,
                'Content-Type': 'application/x-www-form-urlencoded'
                    }
                })
                .then(response => {
                    window.localStorage.setItem('token', response.data.access_token)
                    setLogin(initialLogin)
                    history.push('/')
                })
                .catch(error => {
                    dispatch({type: ERROR, payload: 'Wrong username or password. Try again'})
                })
                .finally(() => {
                    dispatch({type: LOADING_OFF, payload: ''})
                })
        }
    return (
        <Div>
            <Form onSubmit={submitHandler}>
                <Grid container direction={"column"} spacing={2}>
                    <Grid item>
                        <h4>NGHS ENVIRONMENTAL CLUB</h4>
                    </Grid>
                    <Grid item>
                        <StyledTF 
                            label='Username'
                            variant='filled'
                            name='username'
                            value={login.username}
                            onChange={inputHandler}
                            type='text'
                        />
                    </Grid>
                    <Grid item>
                        <StyledTF
                            label='Password'
                            variant='filled'
                            name='password'
                            value={login.password}
                            onChange={inputHandler}
                            type='password'
                        />
                    </Grid>
                    <Grid item>
                        <MuiThemeProvider theme={greenTheme}>
                            <Button type='submit' variant='contained' color='primary'>
                                Login
                            </Button>
                        </MuiThemeProvider>
                    </Grid>
                </Grid>
            </Form>
        </Div>
    );
};

export default Login;